export const bottomFrame =
  "https://static.igem.wiki/teams/4380/wiki/proof-of-concept/hardware/microplate-bottom.png"

export const middleFrame =
  "https://static.igem.wiki/teams/4380/wiki/proof-of-concept/hardware/microplate-middle.png"

export const middleMiddleFrame =
  "https://static.igem.wiki/teams/4380/wiki/proof-of-concept/hardware/microplate-middle.png"

export const topFrame =
  "https://static.igem.wiki/teams/4380/wiki/proof-of-concept/hardware/microplate-top-copy.png"

export const topWhole =
  "https://static.igem.wiki/teams/4380/wiki/proof-of-concept/hardware/microplate-pipette.png"

export const downloadKit =
  "https://static.igem.wiki/teams/4380/wiki/proof-of-concept/hardware/microplate-top.stl"

export const downloadKit2 =
  "https://static.igem.wiki/teams/4380/wiki/proof-of-concept/hardware/microplate-bottom.stl"
